import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetChatPerson, GetChatPersonOne, DelChatPerson} from '../../actions/index';

class Persons extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.addPerson = this.addPerson.bind(this);
        this.editPerson = this.editPerson.bind(this);
        this.delChatPersonOpenModal = this.delChatPersonOpenModal.bind(this);
        this.delChatPerson = this.delChatPerson.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetChatPerson(token);
    }
    delChatPerson(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelChatPerson(this.props.chat.chat_person_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.props.GetChatPerson(token);
            }
        });
    }
    delChatPersonOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that = this;
        $('#DelChatPerson').modal('show');
        $('#DelChatPerson').on('shown.bs.modal', function () {
            that.props.GetChatPersonOne(id, token);
        });
    }
    closeModal(){
        $('#DelChatPerson').modal('hide');
        this.props.chat.chat_person_one = {};
    }

    editPerson(id, item){
        this.context.router.push('/chat/persons/edit/'+id);
    }

    addPerson(){
        this.context.router.push('/chat/persons/add');
    }

    renderTable(){
        return this.props.chat.personsList.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list clearfix two">
                    <p>{i+1}</p>
                    <p><span className="link-span" onClick={this.editPerson.bind(this, item.id)}>{item.name}</span></p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editPerson.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delChatPersonOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }

    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Persons</p>
                            <p className="dashboard-text">Chat</p>
                        </div>
                        <div className="pull-right dashboard-title">
                            <button onClick={this.addPerson} type="button" className="btn btn-primary">
                                <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                Add person
                            </button>
                        </div>
                    </div>
                    {!this.props.chat.personsList.results ?
                        <div className="col-md-12">
                            <p className="white-block text-danger text-center clearfix">Create person please</p>
                        </div>
                        :
                        ""
                    }
                    {this.props.chat.personsList.results && this.props.chat.personsList.results.length > 0 ?
                        <div>
                            <div className="col-md-12">
                                <div className="common-list clearfix two">
                                    <p>#</p>
                                    <p>Name</p>
                                    <p className="pull-right">Option</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {this.renderTable()}
                            </div>
                        </div>
                        :
                        <div className={this.props.chat.personsList.results && this.props.chat.personsList.results.length < 0 || $.isEmptyObject(this.props.chat.personsList) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.chat.personsList.results && this.props.chat.personsList.results.length === 0 && <p className="noResults">No items result</p> }
                    <div className="modal fade" id="DelChatPerson" tabIndex="-1" role="dialog" aria-labelledby="DelChatPersonLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelAdmin"></span>
                                    <p>Do you really want to delete person {this.props.chat.chat_person_one ? <span>{this.props.chat.chat_person_one.name} </span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delChatPerson} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        chat: state.chat
    }
}


export default connect(mapStateToProps, {GetChatPerson, GetChatPersonOne, DelChatPerson})(Persons);




// WEBPACK FOOTER //
// ./src/components/chat/persons.js